<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import Toast from 'dashboard/components-next/toast/Toast.vue';
import { emitter } from 'shared/helpers/mitt';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  duration: {
    type: Number,
    default: 2500,
  },
  position: {
    type: String,
    default: 'bottom-left',
  },
});

const { t } = useI18n();

const snackMessages = ref([]);
const timeoutMap = new Map();

const removeToast = key => {
  const timeout = timeoutMap.get(key);
  if (timeout) {
    clearTimeout(timeout);
    timeoutMap.delete(key);
  }

  snackMessages.value = snackMessages.value.filter(item => item.key !== key);
};

const onNewToastMessage = ({ message: originalMessage, action }) => {
  const message = action?.usei18n ? t(originalMessage) : originalMessage;
  const duration = action?.duration || props.duration;
  const key = Date.now() + Math.random();

  const nextToast = {
    key,
    message,
    action,
  };

  snackMessages.value.push(nextToast);
  timeoutMap.set(
    key,
    window.setTimeout(() => {
      removeToast(key);
    }, duration)
  );
};

onMounted(() => {
  emitter.on('newToastMessage', onNewToastMessage);
});

onUnmounted(() => {
  emitter.off('newToastMessage', onNewToastMessage);
  timeoutMap.forEach(timeout => clearTimeout(timeout));
  timeoutMap.clear();
});
</script>

<template>
  <div
    class="pointer-events-none fixed bottom-4 z-50 flex max-w-[calc(100vw-2rem)] flex-col items-start gap-3 bg-transparent"
    :class="
      position === 'bottom-center' ? 'left-1/2 -translate-x-1/2' : 'left-4'
    "
  >
    <transition-group name="toast-fade" tag="div">
      <Toast
        v-for="snackMessage in snackMessages"
        :key="snackMessage.key"
        :message="snackMessage.message"
        :action="snackMessage.action"
        @close="removeToast(snackMessage.key)"
      />
    </transition-group>
  </div>
</template>
